import React from 'react';
import ActionField from './fields/ActionField';

const DataConnectionActionStep = () => <ActionField />;

export default DataConnectionActionStep;
